var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4309_111123)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.179688,
    width: 40.1803,
    height: 39.4754,
    rx: 8.45902,
    fill: "#1E1850"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 29.7177V17.4034C10 14.475 12.3657 12.1094 15.2812 12.1094H18.299",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6088 20.9199V25.8175C27.6088 27.9658 25.8569 29.7177 23.7086 29.7177H14.8086",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0332 19.1035L20.1917 22.262",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7082 12.4535L26.8667 15.7015L20.1789 22.2614L15.8184 23.6808L17.0204 19.1029L25.0637 11.098C25.9332 10.2413 27.327 10.2413 28.1838 11.1108L29.8334 12.786",
    stroke: "#CBDB2A",
    strokeWidth: 1.13719,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4309_111123"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.179688,
    width: 40.1803,
    height: 39.4754,
    rx: 8.45902,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/EDIT ICON.4ce1ae4f91b74d5bf7fb0392a26e5536.svg";
export { ForwardRef as ReactComponent };